module.exports = __webpack_public_path__ + "static/img/github.8ae9aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/img/footer_icon/hover/github.png
// module id = 0oHH
// module chunks = 0